import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { msalInstance } from './api/msalConfig';

msalInstance.initialize().then(() => {
    ReactDOM.render(<App />, document.getElementById('root'));
}).catch((err) => {
    ReactDOM.render(<App />, document.getElementById('root'));
});